// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function pagoefectivoOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'pagoefectivo',
    payment_type_code: 'pagoefectivo',
    instalments: '1',
  };
}
